<span class="split-order-by">
  <span class="split-text">Split order based on</span>
  <pdq-dropdown
    mode="tight-ghost"
    buttonFontSize="16"
    [border]="false"
    placeholder="split method"
    [options]="splitMethodOptions"
    [defaultOption]="currentSplitMethod || null"
    (onChange)="setSplitOrderMethod($event)">
  </pdq-dropdown>
  @if (!autocompleteSplitMethods.includes(currentSplitMethod?.value)) {
    <span> so each is a separate order in PDQ </span>
  } @else {
    <pdq-dropdown
      class="dropdown"
      mode="tight-ghost"
      [border]="false"
      placeholder="pick operator"
      [defaultOption]="currentSplitMethodOperator2 || null"
      [options]="tempProductTagSplitOperator2"
      buttonFontSize="16"
      (onChange)="setSplitOrderMethodOperator2($event)">
    </pdq-dropdown>
    <pdq-dropdown
      class="dropdown"
      mode="tight-ghost"
      [border]="false"
      placeholder="pick operator"
      [defaultOption]="currentSplitMethodOperator || null"
      [options]="anyAllOperatorsDropdown"
      buttonFontSize="16"
      (onChange)="setSplitOrderMethodOperator($event)">
    </pdq-dropdown>
    @if (isProductTagsSplitOnAutocompleteMode) {
      <div class="auto-complete-wrapper">
        <div class="auto-complete__list-options">
          @for (selectedTag of currentSelectedProductTags; track selectedTag; let tagIndex = $index) {
            <pdq-chip
              #chipRef
              [maxWidth]="maximumAutocompleteWidth"
              [label]="selectedTag.name"
              (onChange)="onProductTagRemove(tagIndex)">
            </pdq-chip>
          }
        </div>
        <pdq-input
          class="tags-container__tagsInput"
          #productTagsInput
          id="productTagsInput"
          [withIcon]="true"
          [placeholder]="currentSplitMethod?.value === 'product_tag' ? 'product tag' : 'add sku list...'"
          icon="search"
          [autofocus]="true"
          [autocompleteMode]="true"
          [autocompleteRef]="pdqAutocomplete"
          [control]="actionProductTagsAutocompleteControl"
          background="light"
          [border]="false"
          [autoCompleteWidth]="419"
          [autoCompleteHeight]="112"
          [offsetPositionX]="-100">
        </pdq-input>
        <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" mode="tags">
          <ng-template pdqAutocompleteContent>
            @if (isLoadingProductTagsResults) {
              <ng-container class="is-loading">
                <pdq-spinner></pdq-spinner>
              </ng-container>
            }
            @if (!isLoadingProductTagsResults) {
              @for (
                productTag of productTags | filterResults: actionProductTagsAutocompleteControl.value;
                track productTag
              ) {
                <pdq-options (click)="onProductTagSelect(productTag)" [value]="productTag.name">
                  <pdq-tag
                    #productTagRef
                    [matTooltip]="ruleTemplateService.isTextOverflowed(productTagRef) ? '' : productTag.name"
                    matTooltipClass="pdq-mat-tooltip"
                    [maxWidth]="maximumAutocompleteWidth">
                    {{ productTag.name }}
                  </pdq-tag>
                </pdq-options>
              }
              @if (!isLoadingProductTagsResults && !productTags.length) {
                <div class="no-results-found">
                  <span class="no-results-found__title"
                    >No results for "{{ actionProductTagsAutocompleteControl.value }}"</span
                  >
                  <span class="no-results-found__subtitle">Maybe try something else?</span>
                </div>
              }
            }
          </ng-template>
        </pdq-autocomplete>
      </div>
    } @else {
      <pdq-input
        placeholder="value"
        [autofocus]="true"
        [value]="splitOrderActionFreeText"
        background="light"
        [border]="false"
        (onKeyup)="onSplitProductTagFreeTextChanged($event)">
      </pdq-input>
    }
  }
</span>
@if (currentSplitMethod?.value === 'sku_list') {
  <div class="sku-list">
    <span>with order tag</span>
    <pdq-input
      placeholder="value"
      [autofocus]="true"
      [value]="tagName"
      background="light"
      [border]="false"
      (onKeyup)="onTagNameTextChanged($event)">
    </pdq-input>
  </div>
}
